<template>
	<div style="zoom: 1">
		<template v-if="is_two_display_mode">
			<div class="uk-flex uk-flex-wrap">
				<div class="uk-width-1-2">
					<header id="header" class="uk-container uk-container-expand uk-padding-small">
						<div class="uk-flex">
							<div class="uk-width-1-6">
								<span class="uk-text-large uk-text-middle uk-align-left" style="margin-bottom: 0px;" @click="move_to_back"><span class="fa fa-thumbtack" style="color: #000;"></span></span>
							</div>
							<div class="uk-width-4-6">
								<h1 id="autoplay" class="uk-text-center uk-text-bold" unselectable="on" style="user-select: none; margin-bottom: 0px;">本日のご予約状況</h1>
							</div>
							<div class="uk-width-1-6">
								<span @click="toggle_mode" class="uk-text-large uk-text-right uk-align-right pointer" style="margin-bottom: 0px;"><span class="fa fa-thumbtack" style="color: #000;"></span></span>
							</div>
						</div>
					</header>
					<div id="reservation_header_wrapper" style="display:none;">
						<div id="reservation_header">
							<div class="row">
							</div>
						</div>
					</div>
					<div id="dp_wrapper">
						<DayPilotCalendar id="dp" :config="daypilot.config" ref="calendar"></DayPilotCalendar>
					</div>
				</div>
				<div class="uk-width-1-2">
					<div id="slider">
						<div id="slider_main" uk-slideshow="autoplay: true; autoplay-interval: 15000; pause-on-hover: true;">
							<ul class="uk-slideshow-items uk-slideshow">
								<template v-for="file in image_files">
									<template v-if="is_pdf(file)">
										<li :key="file">
											<object style="width: 100%; height: 100%;" v-bind:data="file + '#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&view=FitW'" type="application/pdf">
												<iframe style="width: 100%; height: 100%;" v-bind:src="API_BASE + 'public/pdf_viewer/web/viewer.html?file=' + file"></iframe>
											</object>
										</li>
									</template>
									<template v-else>
										<li :key="file"><img style="width: 100%; height: 100%;" v-bind:src="file"></li>
									</template>
								</template>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<header id="header" class="uk-container uk-container-expand uk-padding-small">
				<div class="uk-flex">
					<div class="uk-width-1-5">
						<span class="uk-text-large uk-text-middle uk-align-left" style="margin-bottom: 0px;" @click="move_to_back"><span class="fa fa-thumbtack" style="color: #000;"></span></span>
					</div>
					<div class="uk-width-3-5">
						<h1 class="uk-text-center uk-text-bold" style="margin-bottom: 0px;">本日のご予約状況</h1>
					</div>
					<div class="uk-width-1-5">
						<span @click="toggle_mode" class="uk-text-large uk-text-right uk-align-right pointer" style="margin-bottom: 0px;"><span class="fa fa-thumbtack" style="color: #000;"></span></span>
					</div>
				</div>
			</header>
			<div id="reservation_header_wrapper" style="display:none;">
				<div id="reservation_header">
					<div class="row">
					</div>
				</div>
			</div>
			<div id="dp_wrapper">
				<DayPilotCalendar id="dp" :config="daypilot.config" ref="calendar"></DayPilotCalendar>
			</div>
		</template>
	</div>
</template>

<script>
	import {DayPilot, DayPilotCalendar} from 'daypilot-pro-vue'
	import StaffWorkSchedule from '@/api/StaffWorkSchedule'
	import StaffAuth from '@/api/StaffAuth'
	import ShopReservation from '@/api/ShopReservation'
	import SignageFile from '@/api/SignageFile'

	export default {
		name: 'DigitalSignagePage',
		components: {DayPilot, DayPilotCalendar},
		computed: {
			calendar: function () {
				return this.$refs.calendar.control
			},
			API_BASE: function () {
				return global.API_BASE
			}
		},
		data () {
			return {
				today: moment().format('YYYY-MM-DD'),
				current_staff: null,
				shop_id: null,
				shop: null,
				reservation_list: [],
				staff_work_schedule_list: [],
				image_files: [],
				main_resource_num: 0,
				empty_resource_num: 0,
				work_shop_resource_num: 0,
				is_two_display_mode: false,
				daypilot: {
					config: {
						startDate: this.$route.params.date,
						locale: 'ja-jp',
						/* columnWidthSpec: 'Fixed',
						columnWidth: 100, */
						hourWidth: 100,
						viewType: 'Resources',
						headerLevels: 1,
						headerHeight: 20,
						headerHeightAutoFit: true,
						heightSpec: 'Full',
						/* height: 900, */
						cellHeight: 20,
						crosshairType: 'Header',
						cellDuration: 15,
						timeHeaderCellDuration: 30,
						timeFormat: 'Clock24Hours',
						businessBeginsHour: 7,
						businessEndsHour: 22,
						dayBeginsHour: 7,
						dayEndsHour: 22,
						showCurrentTime: true,
						eventArrangement: 'SideBySide',
						timeRangeSelectedHandling: 'Enabled',
						eventResizeHandling: 'Disabled',
						eventClickHandling: 'Disabled',
						eventDeleteHandling: 'Disabled',
						eventMoveHandling: 'Disabled',
						onTimeRangeSelected: function (args) {
							args.control.clearSelection()
						},
						/* onBeforeEventRender: function (args) {
							args.e.cssClass = 'background_oblique_line'
							return args
						}, */
						onBeforeTimeHeaderRender: function (args) {
							args.header.html = args.header.hours

							if (args.header.minutes == 30) {
								args.header.html += '<span class="time_header_dashed_point"></span>'
							}
						}
					}
				}
			}
		},
		methods: {
			move_to_back () {
				this.$router.push('/reservation_list/' + this.current_staff.shop_id)
			},
			reload_events () {
				let self = this

				StaffWorkSchedule.all(params).then(function (response) {
					self.staff_work_schedule_list = response.data.data
					self.loadEvents()
				})
			},
			to_japanese_num (num) {
				if (num <= 20) {
					const base = '①'.charCodeAt(0)
					return String.fromCharCode(base + num - 1)
				}
				if (num <= 35) {
					const base = '㉑'.charCodeAt(0)
					return String.fromCharCode(base + num - 21)
				}
				if (num <= 50) {
					const base = '㊱'.charCodeAt(0)
					return String.fromCharCode(base + num - 36)
				}
				return num
			},
			toggle_mode () {
				if (this.is_two_display_mode) {
					localStorage.setItem('is_two_display_mode', false)
				} else {
					localStorage.setItem('is_two_display_mode', true)
				}

				window.location.reload()
			},
			is_pdf (file) {
				let type = file.split('.')

				if (type[type.length - 1].toLowerCase() == 'pdf') {
					return true
				}

				return false
			},
			load_images () {
				let self = this

				StaffAuth.current().then(function (response) {
					let staff = response.data.data

					SignageFile.get().then(function (response) {
						let url_list = []

						response.data.data.file_path.forEach(function (value) {
							// url_list.push(S3_URL + 'signage/' + staff.shop_id + '/' + value)
							url_list.push(S3_URL + value)
						})

						self.image_files = url_list
					})
				})
			},
			init () {
				let self = this

				// 現在のスタッフを取得
				StaffAuth.current().then(function (response) {
					self.current_staff = response.data.data
				}).then(function () {
					// 店舗ID
					self.shop_id = self.current_staff.shop_id

					// 店舗
					self.shop = self.current_staff.shop

					// パラメーター定義
					let params = new URLSearchParams()
					params.append('shop_id', self.shop_id)
					params.append('status', 0)
					params.append('q_from_signage', 1)
					params.append('before_start_date', moment().format('YYYY-MM-DD'))
					params.append('after_start_date', moment().format('YYYY-MM-DD'))

					// 出勤情報を取得
					StaffWorkSchedule.all(params).then(function (response) {
						self.staff_work_schedule_list = response.data.data
						/* self.daypilot.config.columnWidth = self.calcCellWidth(self.staff_work_schedule_list.length) */
					}).then(function () {
						self.reservation_list = []

						// 設定読み込み
						/* self.initConfig() */

						// リソース読み込み
						self.loadResources()

						// 設定読み込み
						self.initConfig()

						self.staff_work_schedule_list.forEach(function (value) {
							// パラメーター定義
							let params = new URLSearchParams()
							params.append('response_staff_id', value.staff.id)
							params.append('before_date', moment().format('YYYY-MM-DD'))
							params.append('after_date', moment().format('YYYY-MM-DD'))
							params.append('not_match_status', 3)

							// 予約取得
							ShopReservation.all(params).then(function (response) {
								self.reservation_list = self.reservation_list.concat(response.data.data)
								// イベント読み込み
								self.loadEvents()
							})
						})
					})
				})
			},
			initConfig () {
				this.daypilot.config.businessBeginsHour = this.getStartTime().format('HH')
				this.daypilot.config.dayBeginsHour = this.getStartTime().format('HH')
				this.daypilot.config.businessEndsHour = this.getEndTime().format('HH')
				this.daypilot.config.dayEndsHour = this.getEndTime().format('HH')
				this.daypilot.config.cellHeight = this.calcCellHeight()
				$('#slider').innerHeight(window.innerHeight)
			},
			loadResources () {
				let data = []
				let self = this

				self.main_resource_num = 0
				self.work_shop_resource_num = 0
				self.empty_resource_num = 0

				let today_work_shop_resource_num = 0
				let next_work_shop_resource_num = 0

				let main_count = 1
				let today_work_shop_count = 1
				let next_work_shop_count = 1

				this.staff_work_schedule_list.forEach(function (value) {
					if (value.lane_type == 1) {
						self.main_resource_num++
					}

					if (value.lane_type == 2) {
						self.work_shop_resource_num++
						today_work_shop_resource_num++
					}

					if (value.lane_type == 3) {
						self.work_shop_resource_num++
						next_work_shop_resource_num++
					}
				})

				$('#reservation_header .row').html('')
				$('#reservation_header .row').append('<div class="head" style="width: ' + self.daypilot.config.hourWidth + 'px; overflow: hidden;">&nbsp;</div>')

				this.staff_work_schedule_list.forEach(function (value) {
					if (value.lane_type == 1) {
						/* $('#reservation_header .row').append('<div class="item" style="width: ' + self.calcHeaderCellWidth(self.staff_work_schedule_list.length) + 'px; overflow: hidden;">予約' + self.to_japanese_num(main_count) + '</div>') */

						data.push({
							id: value.staff.id,
							/* name: value.staff.display_name */
							name: '予約' + self.to_japanese_num(main_count)
						})

						main_count++
					}
				})

				this.staff_work_schedule_list.forEach(function (value) {
					if (value.lane_type == 2) {
						let name_value = ''
						if (today_work_shop_resource_num > 1) {
							/* $('#reservation_header .row').append('<div class="item" style="width: ' + (self.calcHeaderCellWidth(self.staff_work_schedule_list.length)) + 'px; overflow: hidden;">本日の教室' + self.to_japanese_num(today_work_shop_count) + '</div>') */
							name_value = '本日の教室' + self.to_japanese_num(today_work_shop_count)
						} else {
							/* $('#reservation_header .row').append('<div class="item" style="width: ' + (self.calcHeaderCellWidth(self.staff_work_schedule_list.length)) + 'px; overflow: hidden;">本日の教室</div>') */
							name_value = '本日の教室'
						}

						data.push({
							id: value.staff.id,
							/* name: value.staff.display_name */
							name: name_value
						})

						today_work_shop_count++
					}
				})

				this.staff_work_schedule_list.forEach(function (value) {
					if (value.lane_type == 3) {
						let name_value = ''
						if (next_work_shop_resource_num > 1) {
							/* $('#reservation_header .row').append('<div class="item" style="width: ' + (self.calcHeaderCellWidth(self.staff_work_schedule_list.length)) + 'px; overflow: hidden;">次回の教室' + self.to_japanese_num(next_work_shop_count) + '</div>') */
							name_value = '次回の教室' + self.to_japanese_num(next_work_shop_count)
						} else {
							/* $('#reservation_header .row').append('<div class="item" style="width: ' + (self.calcHeaderCellWidth(self.staff_work_schedule_list.length)) + 'px; overflow: hidden;">次回の教室</div>') */
							name_value = '次回の教室'
						}

						data.push({
							id: value.staff.id,
							/* name: value.staff.display_name */
							name: name_value
						})

						next_work_shop_count++
					}
				})

				this.calendar.update({columns: data})
			},
			loadEvents () {
				let data = []

				this.reservation_list.forEach(function (value) {
					let display_text = value.signage_display_text == null ? '' : value.signage_display_text

					let html = '<span class="event_job_type_name">' + value.shop_job_type.signage_display_name + '</span>'
					html += '<span class="event_signage_display_text">' + display_text + '</span>'
					html = html.replace('\n', '<br>')

					data.push({
						id: value.id,
						start: new DayPilot.Date(value.date + ' ' + value.plan_start_time),
						end: new DayPilot.Date(value.date + ' ' + value.plan_end_time),
						resource: value.response_staff_id,
						backColor: value.shop_job_type.signage_color.hex,
						text: html
					})
				})

				this.calendar.update({events: data})
			},
			isMobile () {
				let ua = navigator.userAgent

				if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Mobile') > 0) {
					return true
				} else {
					return false
				}
			},
			calcCellHeight () {
				let start = this.getStartTime()
				let end = this.getEndTime()

				let duration = moment.duration(end.diff(start))
				let hours = duration.asHours()

				let headH = $('#header').outerHeight()
				let headerH = $('#reservation_header_wrapper').outerHeight()
				/* let headerDp = this.daypilot.config.headerHeight */
				let headerDp = $('.calendar_default_colheader').outerHeight()
				let hosei = 10

				let result = 0

				let cellCount = hours * (this.daypilot.config.timeHeaderCellDuration / this.daypilot.config.cellDuration) * 2
				let windowArea = Math.floor(window.innerHeight - (headH + headerDp))

				/* result = Math.floor(((((window.innerHeight - 180) / hours) / (this.daypilot.config.timeHeaderCellDuration / this.daypilot.config.cellDuration)) / 2) * 100) / 100 */
				// result = Math.floor(((window.innerHeight - (headH + headerH + hosei)) / (hours * (this.daypilot.config.timeHeaderCellDuration / this.daypilot.config.cellDuration) * 2)) * 10) / 10
				result = Math.floor((window.innerHeight - (headH + headerDp)) / (hours * (this.daypilot.config.timeHeaderCellDuration / this.daypilot.config.cellDuration) * 2))

				// return Math.floor(result)
				return result
			},
			/* calcCellWidth (cell_length) {
				let width = window.innerWidth
				let result = 0

				if (localStorage.getItem('is_two_display_mode') == 'true') {
					result = Math.floor(((width / 2) / cell_length) - (this.daypilot.config.hourWidth / cell_length)) - (30 / cell_length)
				} else {
					result = Math.floor((width / cell_length) - (this.daypilot.config.hourWidth / cell_length)) - (30 / cell_length)
				}

				return Math.ceil(result)
			},
			calcHeaderCellWidth (cell_length) {
				let width = window.innerWidth
				let result = 0

				if (localStorage.getItem('is_two_display_mode') == 'true') {
					result = Math.floor(((width / 2) / cell_length) - (this.daypilot.config.hourWidth / cell_length)) - (30 / cell_length)
				} else {
					result = Math.floor((width / cell_length) - (this.daypilot.config.hourWidth / cell_length)) - (30 / cell_length)
				}

				return Math.ceil(result)
			}, */
			getStartTime () {
				if (this.isHoliday()) {
					if (this.shop.wn_business_time_start == null) {
						return moment().hour(10)
					}

					return moment(moment().format('YYYY-MM-DD') + ' ' + this.shop.wn_business_time_start)
				}

				if (this.shop.business_time_start == null) {
					return moment().hour(10)
				}

				return moment(moment().format('YYYY-MM-DD') + ' ' + this.shop.business_time_start)
			},
			getEndTime () {
				if (this.isHoliday()) {
					if (this.shop.wn_business_time_end == null) {
						return moment().hour(20)
					}

					return moment(moment().format('YYYY-MM-DD') + ' ' + this.shop.wn_business_time_end)
				}

				if (this.shop.business_time_end == null) {
					return moment().hour(20)
				}

				return moment(moment().format('YYYY-MM-DD') + ' ' + this.shop.business_time_end)
			},
			isHoliday () {
				let holidayList = {
					2025: {
						0: [1, 13],
						1: [11, 23, 24],
						2: [20],
						3: [29],
						4: [3, 4, 5, 6],
						5: [],
						6: [21],
						7: [11],
						8: [15, 23],
						9: [13],
						10: [3, 23, 24],
						11: []
					},
					2026: {
						0: [1, 12],
						1: [11, 23],
						2: [20],
						3: [29],
						4: [3, 4, 5, 6],
						5: [],
						6: [20],
						7: [11],
						8: [21, 22, 23],
						9: [12],
						10: [3, 23],
						11: []
					},
					2027: {
						0: [1, 11],
						1: [11, 23],
						2: [21, 22],
						3: [29],
						4: [3, 4, 5],
						5: [],
						6: [19],
						7: [11],
						8: [20, 23],
						9: [11],
						10: [3, 23],
						11: []
					},
					2028: {
						0: [1, 10],
						1: [11, 23],
						2: [20],
						3: [29],
						4: [3, 4, 5],
						5: [],
						6: [17],
						7: [11],
						8: [18, 22],
						9: [9],
						10: [3, 23],
						11: []
					},
					2029: {
						0: [1, 8],
						1: [11, 12, 23],
						2: [20],
						3: [29, 30],
						4: [3, 4, 5],
						5: [],
						6: [16],
						7: [11],
						8: [17, 23, 24],
						9: [8],
						10: [3, 23],
						11: []
					},
					2030: {
						0: [1, 14],
						1: [11, 23],
						2: [20],
						3: [29],
						4: [3, 4, 5, 6],
						5: [],
						6: [15],
						7: [11, 12],
						8: [16, 23],
						9: [14],
						10: [3, 4, 23],
						11: []
					}
				}

				// 今日の日付
				let date = new Date()

				// 年月日を取得
				let y = date.getFullYear()
				let m = date.getMonth()
				let d = date.getDate()

				let dayOfWeek = date.getDay()
				let dayOfWeekStr = ['日', '月', '火', '水', '木', '金', '土'][dayOfWeek]

				// 祝日リストに日付が含まれるか
				return holidayList[y][m].indexOf(d) !== -1 || dayOfWeekStr == '土' || dayOfWeekStr == '日'
			}
		},
		created () {
			let self = this
			this.is_two_display_mode = localStorage.getItem('is_two_display_mode') == 'true'

			StaffAuth.current().then(response => {
				self.current_staff = response.data.data
			})
		},
		beforeMount () {
			this.init()
			this.load_images()
		},
		mounted () {
			let self = this

			let scheduler_header = $('#reservation_header')
			let scheduler_scroll_container = $('.calendar_default_scroll > div > div:last-of-type')

			scheduler_scroll_container.on('scroll', function () {
				scheduler_header.css('margin-left', -scheduler_scroll_container.scrollLeft())
			})

			// 自動更新
			setInterval(() => {
				let params = new URLSearchParams()
				params.append('shop_id', self.current_staff.shop_id)

				ShopReservation.checkRefresh(params).then(response => {
					if (response.data.data != 0) {
						self.init()
					}
				})
			}, 3000)

			// 画面回転時
			$(window).on('orientationchange', (event) => {
				location.reload()
			})

			// ウィンドウサイズ変更時 ここから
			let window_resize_timer = null

			$(window).on('resize', (event) => {
				if (window_resize_timer != null) {
					clearTimeout(timer)
				}

				window_resize_timer = setTimeout(function () {
					location.reload()
				}, 200)
			})

			// ウィンドウサイズ変更時 ここまで

			// オートプレイ再開 ここから
			let slideshow = UIkit.slideshow($('#slider_main'))

			$('#autoplay').click(function () {
				slideshow.startAutoplay()
				alert('スライドショーの再生を再開しました。')
			})
			// オートプレイ再開 ここまで
		}
	}
</script>

<style lang="scss">
	.pointer {
		cursor: pointer;
	}

	#reservation_header_wrapper {
		overflow: hidden;
	}

	#reservation_header {
		width: 100%;
		display: table;
		border-collapse: separate !important;
		border-spacing: 0 !important;
		table-layout: fixed !important;

		.row {
			display: block;
			overflow: hidden;
			border-top: solid 1px #ccc;
			border-bottom: solid 1px #ccc;

			.head {
				display: table-cell;
				vertical-align: middle;
				border-left: solid 1px #ccc;
				border-right: solid 1px #ccc;
				box-sizing: border-box !important;
				font-size: 14px;
				text-align: center;
			}

			.item {
				display: table-cell;
				vertical-align: middle;
				border-right: solid 1px #ccc;
				box-sizing: border-box !important;
				font-size: 20px;
				font-weight: bold;
				text-align: center;
				background: #D8D8D8;
				color: #333333;
			}
		}
	}

	#slider {
		height: 100%;
		background: #fff;
		padding: 20px;

		.uk-slideshow {
			height: 100%;
		}

		.uk-slideshow-items img {
			object-fit: contain;
		}
	}
	#slider_main {
		background: #fff;
	}

	#dp_wrapper {
		overflow: hidden;

		* {
			box-sizing: border-box !important;
		}

		table {
			table-layout: fixed !important;
			border-collapse: collapse !important;
		}

		.background_oblique_line .calendar_default_event_inner {
			background-image: -webkit-gradient(linear, 0 0, 100% 100%, color-stop(.25, #F9F9F9), color-stop(.25, transparent), color-stop(.5, transparent), color-stop(.5, #F9F9F9), color-stop(.75, #F9F9F9), color-stop(.75, transparent), to(transparent)) !important;
			-webkit-background-size: 14px 14px !important;
		}

		.calendar_default_cell_inner {
			border-bottom: none !important;
		}

		tr:nth-child(odd) .calendar_default_rowheader .calendar_default_rowheader_inner {
			border-bottom: dashed 1px #ccc !important;
		}

		tr:nth-child(even) .calendar_default_rowheader .calendar_default_rowheader_inner {
			border-bottom: solid 1px #ccc !important;
		}

		.calendar_default_rowheader {
			.calendar_default_rowheader_inner {
				font-size: 20px !important;
				font-weight: bold !important;
				text-align: center !important;
				vertical-align: middle !important;
				border-right: solid 1px #ccc !important;
				border-bottom: none !important;
				background: #D8D8D8;
			}
		}

		.calendar_default_colheader {
			.calendar_default_colheader_inner {
				font-size: 20px !important;
				font-weight: bold !important;
				text-align: center !important;
				vertical-align: middle !important;
				border-right: solid 1px #ccc !important;
				border-bottom: none !important;
				background: #D8D8D8;
			}
		}

		.calendar_default_main {
			border: none !important;
		}

		/* .calendar_default_scroll {
			border-top: solid 1px #ccc !important;
		} */

		.calendar_default_rowheader_minutes {
			display: none !important;
		}


		/* .calendar_default_scroll > div:first-of-type > div:last-of-type > div:first-of-type > table:first-of-type tbody tr td > div {
			border-right: solid 1px #ccc !important;
		} */

		.calendar_default_scroll > div:first-of-type > div:last-of-type > div:first-of-type > table:first-of-type tbody tr:nth-child(2n) td > div {
			border-bottom: dashed 1px #ccc !important;
		}

		.calendar_default_scroll > div:first-of-type > div:last-of-type > div:first-of-type > table:first-of-type tbody tr:nth-child(4n) td > div {
			border-bottom: solid 1px #ccc !important;
		}

		.calendar_default_event_inner span {
			padding: 4px 0;
			color: #000 !important;
			font-size: 14px !important;
			font-weight: bold !important;
			text-align: center !important;
			vertical-align: middle !important;
			display: block;
		}

		.calendar_default_corner {
			display: none !important;
		}

		.event_signage_job_type_name {
			display: block;
		}

		.event_signage_display_name {
			margin-top: 10px;
			display: block;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/DigitalSignagePage.vue